import { message } from "antd";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { PopupConfirm } from "../../../../../atoms/Popup";
import { getBookingDetail, updateBookingStatus } from "../../../../BookingForm/ducks/actions";

export const useSubmitRenewalForApproval = () => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const { leaseId = "" } = useParams();

  const submitForApproval = () => {
    if (!leaseId) {
      message.error("Lease ID is missing. Unable to submit for approval.");
      return;
    }

    PopupConfirm({
      title: "Are you sure you want to submit this renewal for approval?",
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        try {
          await dispatch(updateBookingStatus({ leaseId, body: { renewalSendForApproval: "yes" } }));
          await dispatch(getBookingDetail(leaseId));
          message.success("Renewal submitted for approval");
          navigate(`/viewbookingform/${leaseId}`, { state: { renewal: true } });
        } catch {
          message.error("Failed to submit renewal for approval");
        }
      },
    });
  };

  const saveDraft = () => {
    message.success("Draft saved");
  };

  return { submitForApproval, saveDraft };
};
